const NON_OPTIMIZELY_FEATURE_FLAGS = {
  PAID_SUBS_SETUP_REQUIRES_STRIPE_KYC_DATA:
    'paid_subs_setup_requires_stripe_kyc_data',
};

const FEATURE_FLAG_CONFIG = {
  [NON_OPTIMIZELY_FEATURE_FLAGS.PAID_SUBS_SETUP_REQUIRES_STRIPE_KYC_DATA]: {
    development: true,
    production: false,
  },
};

const parseEnvironment = anchorEnvironment => {
  if (!anchorEnvironment || ['test', 'local'].includes(anchorEnvironment)) {
    return 'development';
  }
  return anchorEnvironment === 'staging' ? 'production' : anchorEnvironment;
};

const getFeatureFlag = featureFlagName => {
  const environment = ENVIRONMENT;
  if (!environment) {
    console.warn(
      `ENVIRONMENT not set, cannot look up feature flag ${featureFlagName}`
    );
    return null;
  }

  if (!featureFlagName) {
    console.warn(
      `Invalid feature flag name. featureFlagName=${featureFlagName}`
    );
    return null;
  }

  const config = FEATURE_FLAG_CONFIG[featureFlagName];

  if (!config) {
    console.warn(`No feature flag config found for ${featureFlagName}`);
    return null;
  }

  const featureFlag = config[parseEnvironment(environment)];

  if (featureFlag === undefined) {
    console.warn(
      `Feature flag not set for flag=${featureFlag} environment=${environment}`
    );
    return null;
  }

  return featureFlag;
};

module.exports = {
  NON_OPTIMIZELY_FEATURE_FLAGS,
  getFeatureFlag,
};
